import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';

const friendlyHttpStatus = {
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  203: 'Non-Authoritative Information',
  204: 'No Content',
  205: 'Reset Content',
  206: 'Partial Content',
  300: 'Multiple Choices',
  301: 'Moved Permanently',
  302: 'Found',
  303: 'See Other',
  304: 'Not Modified',
  305: 'Use Proxy',
  306: 'Unused',
  307: 'Temporary Redirect',
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Required',
  413: 'Request Entry Too Large',
  414: 'Request-URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Requested Range Not Satisfiable',
  417: 'Expectation Failed',
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
  505: 'HTTP Version Not Supported',
};

export class ErrorDto {
  httpStatus: number;
  httpStatusMessage: string;
  errorMessage: string;
}

export abstract class BaseService {

  protected constructor() {}

  protected handleError(error: HttpErrorResponse, errorDto: ErrorDto) {
    errorDto.httpStatus = error.status == 0 ? 500 : error.status;
    errorDto.httpStatusMessage = friendlyHttpStatus[errorDto.httpStatus];
    errorDto.errorMessage = error.status == 0 ? 'Server site unavailable' : error.error.message;
    console.error(error);
    return throwError(() => error);
  }

  protected addParamIntoUrl(url: string, parameter: any) {
    return url + '/' + parameter;
  }
}
